package presentation.screens.common.address_screen.list

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import component.address.AddressCard
import component.button.DefaultButton
import component.empty.EmptyData
import component.navigation.TopNavBar
import feature.address.viewModel.AddressViewModel
import presentation.screens.common.address_screen.create.CreateAddressScreen

class AddressListScreen : Screen {
    @Composable
    override fun Content() {
        val navigator = LocalNavigator.current
        val viewModel = AddressViewModel()
        val addressList = viewModel.allData.collectAsState()
        Column(modifier = Modifier.fillMaxHeight()) {
            TopNavBar(title = "Address", onBackPress = { navigator?.pop() }, onClickAdd = {
                navigator?.push(CreateAddressScreen())
            })
            if (addressList.value.isEmpty()) {
                EmptyData(name = "Address", viewModel = viewModel) {

                }
                DefaultButton(
                    title = "Create New Address",
                    onClick = {
                        navigator?.push(CreateAddressScreen())
                    },
                    modifier = Modifier.fillMaxWidth()
                )
            } else {
                LazyColumn(
                    contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp),
                    modifier = Modifier
                        .fillMaxHeight()
                        .fillMaxWidth()
                ) {
                    items(
                        items = addressList.value,
                        itemContent = {
                            AddressCard(address = it, onClick = {})
                        })
                }
            }

        }
    }
}